export function getCachedServiceCenter() {
  const cachedServiceCenter = JSON.parse(localStorage.getItem('serviceCenter'));
  return cachedServiceCenter && cachedServiceCenter.value;
}

export function cacheSelectedServiceCenter(serviceCenter) {
  localStorage.setItem('serviceCenter', JSON.stringify({ value: serviceCenter }));
  return getCachedServiceCenter();
}
